const Description = ({ description }) => {
  const baseContainer = 'relative w-full mt-smallMobile md:mt-smallMobile'
  const base = 'font-chivoMono text-olive text-bodyMobile md:text-bodyDesktop'

  return (
    <div className={baseContainer}>
      <p className={base}>{description}</p>
    </div>
  )
}

export default Description
